import React from 'react';
import { exportComponentAsJPEG } from 'react-component-export-image';
import { Link } from 'react-router-dom';
import logo from '../images/logo.svg'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { MemeComponent } from '../pages/Templates/Career-fair/CareerFair'

const styles = {
  appBar: {
    position: 'relative',
    backgroundColor: '#0F161F'
  },
  flex: {
    flex: 1,
  },
  imgContainer: {
    position: 'relative',
    flex: 1,
    padding: 16,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
}

class ImgPreview extends React.Component {
  constructor(props) {
    super(props);
    this.memeRef = React.createRef();
  }

  render() {
    const { classes } = this.props
    return (
      <Dialog
        fullScreen
        open={!!this.props.img}
        onClose={this.props.onClose}
      >
        <AppBar className={classes.appBar}>
          <Toolbar className="flex justify-between">
            <Link to='/' className="h-8 w-8">
              <img src={logo} alt='logo' />
            </Link>
            <IconButton
              color="inherit"
              onClick={this.props.onClose}
              aria-label="Close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <div className="exportContainer h-full p-4 flex flex-col items-center justify-center">
          <MemeComponent img={this.props.img} ref={this.memeRef} />
          <button className="meme-download" onClick={() => exportComponentAsJPEG(this.memeRef, {fileName: 'SecureTheBag'})}>Download Meme</button>
        </div>
      </Dialog>
    )
  }
}

export default withStyles(styles)(ImgPreview);